import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../common/SEO';

const NotFound = () => {
  return (
    <>
      <SEO title="Stránka nenalezena | LightWell" description="Litujeme, ale požadovaná stránka neexistuje." path="/404" />
      <div className="min-h-screen flex items-center justify-center bg-gray-50 pt-20 px-4">
        <div className="text-center">
          <h1 className="text-9xl font-bold text-blue-600 italic tracking-tighter mb-4">404</h1>
          <h2 className="text-3xl font-bold text-gray-900 uppercase mb-8">Stránka nenalezena</h2>
          <p className="text-gray-500 mb-12 max-w-md mx-auto">Omlouváme se, ale adresa, kterou hledáte, buď neexistuje, nebo byla přesunuta.</p>
          <Link to="/" className="inline-block px-10 py-4 bg-blue-600 text-white rounded-full font-bold uppercase tracking-widest hover:bg-blue-700 transition-all">
            Zpět na hlavní stránku
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;